import { createStore } from 'solid-js/store'
import EARTH_BG from '~/assets/earth-day-bg.webp'
import EARTH_PRIZE from '~/assets/earth-day-prize.png'
import SPRING_BG from '~/assets/spring-fest-bg.webp'
import SPRING_PRIZE from '~/assets/spring-fest-prize.png'
import { m } from '~/paraglide/messages'

export type CampaignEvent = {
  id: string
  title: () => string
  iconImg: string
  bgImg: string
  bgFlip: boolean
  bgPosition: string
  validStartDate: string
  validEndDate: string
  visibleEndDate: string
  url: string

  isUnderMaintenance: boolean
}

const INITIAL_EVENTS: CampaignEvent[] = [
  {
    isUnderMaintenance: false,

    id: 'spring-focus-fest',
    title: () => '生日活動',
    iconImg: SPRING_PRIZE,
    bgImg: SPRING_BG,
    bgFlip: false,
    bgPosition: '50% 50%',
    url:
      import.meta.env.MODE === 'production'
        ? 'https://forest-pass.seekrtech.com'
        : 'https://forest-birthday-campaign-staging.seekrtech.com',

    ...(import.meta.env.MODE === 'production'
      ? {
          validStartDate: '2026-03-30T10:00+08:00',
          validEndDate: '2026-04-30T10:00+08:00',
          visibleEndDate: '2026-05-15T10:00+08:00',
        }
      : {
          validStartDate: new Date().toISOString(),
          validEndDate: new Date(
            Date.now() + 7 * 24 * 60 * 60 * 1000,
          ).toISOString(),
          visibleEndDate: new Date(
            Date.now() + 7 * 24 * 60 * 60 * 1000,
          ).toISOString(),
        }),
  },
  {
    isUnderMaintenance: false,

    id: 'earth-day',
    title: () => m.event_title_earth_day(),
    iconImg: EARTH_PRIZE,
    bgImg: EARTH_BG,
    bgFlip: true,
    bgPosition: '50% 60%',
    url:
      import.meta.env.MODE === 'production'
        ? 'https://forest-earth-day.seekrtech.com'
        : 'https://forest-earth-day-staging.seekrtech.com',

    ...(import.meta.env.MODE === 'production'
      ? {
          validStartDate: '2026-04-21T10:00+08:00',
          validEndDate: '2026-05-05T10:00+08:00',
          visibleEndDate: '2026-05-05T10:00+08:00',
        }
      : {
          validStartDate: new Date().toISOString(),
          validEndDate: new Date(
            Date.now() + 7 * 24 * 60 * 60 * 1000,
          ).toISOString(),
          visibleEndDate: new Date(
            Date.now() + 7 * 24 * 60 * 60 * 1000,
          ).toISOString(),
        }),
  },
]

export const [events, setEvents] = createStore(INITIAL_EVENTS)

export function getEventById(id: string) {
  return events.find((e) => e.id === id)
}

export function resetEvents() {
  setEvents(INITIAL_EVENTS.map((e) => ({ ...e })))
}
